/* LORENS — JS bug fixes (Claude). Loaded after the product page inline script so overrides win. */
(function () {
  function lbOpenCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    var opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) { opener.click(); return true; }
    try { if (typeof drawer.show === 'function') { drawer.show(); return true; } } catch (e) {}
    drawer.setAttribute('open', '');
    return true;
  }
  window.lbOpenCartDrawer = lbOpenCartDrawer;

  function lbAddVariant(variantId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.textContent = 'מוסיף...'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.textContent = '✓ נוסף!';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
        try { lbOpenCartDrawer(); } catch (e) {}
        if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = 'הוספה לסל'; }, 2000);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'שגיאה, נסה שוב'; setTimeout(function () { btn.textContent = 'הוספה לסל'; }, 2000); }
      });
  }

  function lbSizeOptionOf(product) {
    return (product.options || []).map(function (o, i) {
      if (typeof o === 'string') return { name: o, position: i + 1, values: null };
      return o;
    }).filter(function (o) {
      var n = (o.name || '').toLowerCase();
      return n.indexOf('size') > -1 || n.indexOf('מידה') > -1 || n.indexOf('מידות') > -1;
    })[0];
  }

  function lbShowSizeChooser(card, product, sizeOpt, triggerBtn) {
    if (!card) return;
    var existing = card.querySelector('.cov-sizes');
    if (existing) { existing.remove(); return; }
    var pos = sizeOpt.position || 1;
    var wrap = document.createElement('div');
    wrap.className = 'cov-sizes';
    wrap.addEventListener('click', function (e) { e.stopPropagation(); });
    var title = document.createElement('div');
    title.className = 'cov-sizes__title';
    title.textContent = 'בחרו מידה:';
    wrap.appendChild(title);
    var list = document.createElement('div');
    list.className = 'cov-sizes__list';
    var values = sizeOpt.values || product.variants.map(function (v) { return v['option' + pos]; });
    var seen = {};
    values.filter(function (v) { if (!v || seen[v]) return false; seen[v] = 1; return true; }).forEach(function (val) {
      var variant = product.variants.filter(function (v) { return v['option' + pos] === val; })[0];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cov-size';
      b.textContent = val;
      if (!variant || !variant.available) {
        b.className += ' is-soldout';
        b.disabled = true;
      } else {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          lbAddVariant(variant.id, triggerBtn);
          wrap.remove();
        });
      }
      list.appendChild(b);
    });
    wrap.appendChild(list);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cov-sizes__close';
    close.setAttribute('aria-label', 'סגור');
    close.textContent = '×';
    close.addEventListener('click', function (ev) { ev.stopPropagation(); wrap.remove(); });
    wrap.appendChild(close);
    card.appendChild(wrap);
  }

  // Coverflow "add to cart": if the product has size variants, let the customer choose a size first.
  window.lbCovAddToCart = function (btn) {
    if (!btn) return;
    var card = btn.closest('.cov-card') || btn.parentElement;
    var directId = btn.getAttribute('data-variant-id');
    var link = card && card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var handle = '';
    try { handle = href.split('/products/')[1].split('?')[0].split('#')[0]; } catch (e) {}
    if (!handle) { return lbAddVariant(directId, btn); }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.disabled = false;
        btn.textContent = original;
        var sizeOpt = lbSizeOptionOf(p);
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!sizeOpt || p.variants.length <= 1) {
          return lbAddVariant((avail[0] || p.variants[0]).id, btn);
        }
        lbShowSizeChooser(card, p, sizeOpt, btn);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        lbAddVariant(directId, btn);
      });
  };

  // "הסל שלך" (view cart) button opens the SIDE drawer instead of the /cart page.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a.button[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var url;
    try { url = new URL(href, location.origin); } catch (_) { return; }
    var path = url.pathname.replace(/\/+$/, '');
    if (!/\/cart$/.test(path)) return;
    if (!document.getElementById('cart-drawer')) return;
    e.preventDefault();
    e.stopPropagation();
    lbOpenCartDrawer();
  }, true);
})();
